import React, { useEffect, useCallback } from 'react';
import { IS_TEST, IS_DEV } from '@zero/mc-utils';
import { getTemplateConfig } from '@/apis/templateConfig';
import { isLocalJDTest, isLocal } from '@/constants/config';
import { useSelector } from 'react-redux';

export const CodeID = IS_DEV || isLocalJDTest ? 158 : IS_TEST || isLocal ? 226 : 77;

/**
 * AI Autobots组件
 * 用于加载和渲染AI对话气泡组件
 * @param {any} props - 组件属性
 * @returns {JSX.Element} 返回AI对话气泡容器
 */
function AIAutobots(props: any) {
  const userInfo = useSelector<any, any>((state) => state?.userInfo);
  const loadScripts = useCallback(() => {
    loadScriptsNew('https://storage.jd.com/taro/aigc-ui/1.0.19/aigcjdfe-autobots-full.umd.js')
      .then((fed: any) => {
        fed?.renderAiChatBubble(
          {
            width: 500,
            height: 700,
            chatInfo: {
              agentId: '9556',
              token: 'b360cf44c5da4856a8af2b12777036d6',
            },
          },
          'AI-autobots'
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getTemplateConfig(CodeID).then((res) => {
      if (res.success) {
        const { projectSchema = [] } = res.data || {};
        const sceneItem = projectSchema.find((item: any) => item.sceneCode === 'AICODE') || {};
        const sceneContent = sceneItem.sceneContent || [];
        //构造使用方需要的数据 使用key,value的形式进行存储,key:functionCode,value:functionContent
        let _sceneContent = {} as any;
        sceneContent.forEach((functionItem: any) => {
          if (functionItem.functionValue === 'true') {
            _sceneContent[functionItem.functionCode] = true;
          } else if (functionItem.functionValue === 'false') {
            _sceneContent[functionItem.functionCode] = false;
          } else {
            _sceneContent[functionItem.functionCode] = functionItem.functionValue;
          }
        });
        //新增AI开关，如果AIDialogue为空或false：关闭AI助手；为true：放开所有人可见；'raoenhui':仅erp可见
        let { AIDialogue } = _sceneContent;
        console.log('AIDialogue', AIDialogue, userInfo?.userMap?.erp);
        if (AIDialogue === true || AIDialogue?.split(',')?.indexOf(userInfo?.userMap?.erp) > -1) {
          loadScripts();
        }
      }
    });
  }, [loadScripts, userInfo?.userMap?.erp]);

  /**
   * 动态加载外部JavaScript文件
   * @param {string} src - 脚本文件的URL地址
   * @returns {Promise<any>} 返回一个Promise，resolve时返回window['autobots-full']对象
   */
  async function loadScriptsNew(src: any) {
    let resolve: any, reject: any;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    const scriptDom = document.createElement('script');
    scriptDom.type = 'text/javascript';
    scriptDom.addEventListener('load', (ev) => resolve(window['autobots-full']));
    // scriptDom.addEventListener('load', (ev) => resolve(undefined))
    scriptDom.addEventListener('error', (ev) => reject(ev));
    scriptDom.src = src;
    scriptDom.defer = true;
    document.body.appendChild(scriptDom);

    return promise;
  }

  return <div id="AI-autobots"></div>;
}

export default AIAutobots;
